export default {"src":"/_next/static/media/Holistic Approach to Health cardiology.05cc14c0.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};